import { render, staticRenderFns } from "./Sidecar.vue?vue&type=template&id=2a117172&"
import script from "./Sidecar.vue?vue&type=script&lang=js&"
export * from "./Sidecar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports